import React from "react"
import useDebounceQueryParams from "magik-react-hooks/useRouterDebounceQueryParams"
import Column from "../Column/Column"
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { Delete, Edit } from "@material-ui/icons"
import { Pagination } from "@material-ui/lab"
import moment from "moment"
import { isMobile } from "react-device-detect"

export default function ListAziende({
  aziende,
  onUpdate,
  onDelete,
  columnProps,
  pagination,
}) {
  const [
    queryParams,
    setQueryParams,
    debQueryParams,
    setDebQueryParams,
  ] = useDebounceQueryParams()
  return (
    <Card>
      <CardHeader title="Aziende" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow style={{ fontWeight: "bold" }}>
                <Column {...columnProps} field="rag_sociale">
                  Ragione sociale
                </Column>
                {!isMobile && (
                  <>
                    <Column {...columnProps} field="p_iva">
                      Partita IVA
                    </Column>
                    <Column {...columnProps} field="numero_licenze">
                      Numero licenze
                    </Column>
                    <Column {...columnProps} field="scadenza_licenza">
                      Scadenza licenze
                    </Column>
                  </>
                )}
                <TableCell>Azioni</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {aziende &&
                aziende.map((azienda) => (
                  <TableRow key={azienda.id}>
                    <TableCell>{azienda.rag_sociale}</TableCell>
                    {!isMobile && (
                      <>
                        <TableCell>{azienda.p_iva}</TableCell>
                        <TableCell>{azienda.numero_licenze}</TableCell>
                        <TableCell>
                          {azienda.scadenza_licenza
                            ? moment(azienda.scadenza_licenza).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </TableCell>
                      </>
                    )}
                    <TableCell>
                      <IconButton
                        onClick={() => onUpdate(azienda)}
                        aria-label="modifica"
                        title="Modifica azienda"
                      >
                        <Edit style={{ color: "orange" }} />
                      </IconButton>
                      <IconButton
                        onClick={() => onDelete(azienda)}
                        aria-label="elimina"
                        title="Elimina azienda"
                      >
                        <Delete style={{ color: "red" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      <Pagination
        style={{ marginTop: 10, display: "flex", justifyContent: "center" }}
        count={pagination.numPages}
        color="primary"
        page={+debQueryParams.page || 1}
        onChange={(e, page) => setQueryParams({ page })}
      />
    </Card>
  )
}
